export const SectionHeading = ({ eyebrow, title, description, align = "left", className = "" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} ${className}`}>
    {eyebrow && (
      <div className={`eyebrow mb-4 ${align === "center" ? "justify-center" : ""}`}>
        <span className="tie" aria-hidden />
        {eyebrow}
      </div>
    )}
    <h2 className="font-display text-[clamp(1.9rem,1.2rem+2.4vw,2.9rem)] leading-[1.08] tracking-[-0.015em] text-stone">
      {title}
    </h2>
    {description && <p className="mt-5 text-lg leading-relaxed text-muted-foreground">{description}</p>}
  </div>
);

export default SectionHeading;
